<template>
  <CFooter :fixed="false">

    <CCol col="6">
      <div class="ml-auto" >
      <a href="https://ibsteam.co" target="_blank">
        <img   width="auto" height="25px" :src="footer_image"/>
      </a>
        <strong class="mr-2 ml-2  text-start"  >{{footer_text_right}}</strong>
        <!--      <a href="https://coreui.io/vue" target="_blank"></a>-->
      </div>
    </CCol>

    <CCol col="6" class="text-end">
    <div class="text-end" style="text-align: end">
      <strong class="ml-1">{{ footer_text_left }}</strong>
    </div>
  </CCol>



  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter',
  data(){
    return {
      footer_text_right : localStorage.getItem('footer_text_right'),
      footer_text_left : localStorage.getItem('footer_text_left'),
      footer_image : localStorage.getItem('footer_image'),
    }
  }
}
</script>
